import { motion } from 'framer-motion';
import shared from '../../styles/shared.module.css';
import styles from './HelpSection.module.css';
import { staggerContainer, cardVariant } from '../../animations';
import { ManifestoPlayer } from '../ManifestoPlayer/ManifestoPlayer';

import bookIcon from '../../assets/figma/figma-08.png';
import sparkleIcon from '../../assets/figma/figma-06.png';
import graduationIcon from '../../assets/figma/figma-13.png';
import headingHelp from '../../assets/figma/page13/heading-help.png';

const helpCards = [
  {
    title: 'Projetos Arquitetônicos',
    text: 'Essa é a nossa principal área de atuação, com foco em ambientes residenciais infantis e espaços comerciais voltados para crianças. Aqui, transformamos sonhos em projetos arquitetônicos funcionais, acolhedores e visualmente encantadores.',
    icon: sparkleIcon,
    cardClass: styles.helpCardBlue,
    badgeClass: styles.badgeBlue,
  },
  {
    title: 'Consultoria de Ambientes',
    text: 'Com foco em ambientes residenciais infantis essa é uma opção para quem gosta de colocar a mão na massa ou quer uma solução mais simples, criando ambientes que equilibram personalidade, funcionalidade e desenvolvimento infantil.',
    icon: graduationIcon,
    cardClass: styles.helpCardCream,
    badgeClass: styles.badgePink,
  },
  {
    title: 'Produtos Digitais para Mães',
    text: 'Pensando nas mães que desejam fazer parte do processo criativo ou realizar projetos de forma independente, desenvolvemos duas soluções:',
    details: [
      'Curso Digital: "Como montar o quarto de bebê dos sonhos", ideal para quem busca criar um ambiente especial e personalizado sem a necessidade de contratar um arquiteto.',
      'Manual Digital: Um guia prático e acessível, repleto de dicas e inspirações para decoração infantil, pensado para facilitar o design de espaços encantadores.',
    ],
    icon: bookIcon,
    cardClass: styles.helpCardGreen,
    badgeClass: styles.badgeOrange,
  },
];

export function HelpSection() {
  return (
    <section id="servicos" className={styles.helpSection}>
      <div className={shared.frame}>
        <div className={styles.helpIntro}>
          <h2 className={`${shared.assetHeading} ${styles.helpHeading}`}>
            <img src={headingHelp} alt="Como posso ajudar" />
          </h2>

          <div className={styles.helpLead}>
            <p>
              Toda Criança merece ter um lugar só seu, onde possa sonhar, brincar e crescer com
              segurança e alegria.
            </p>
            <ManifestoPlayer />
          </div>
        </div>

        <motion.div
          className={styles.helpCards}
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {helpCards.map((card) => (
            <motion.article
              className={`${styles.helpCard} ${card.cardClass}`}
              key={card.title}
              variants={cardVariant}
            >
              <span className={`${styles.iconBadge} ${card.badgeClass}`}>
                <img src={card.icon} alt="" aria-hidden="true" />
              </span>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
              {card.details?.map((detail) => (
                <p className={styles.cardDetail} key={detail}>
                  {detail}
                </p>
              ))}
            </motion.article>
          ))}
        </motion.div>

        <p className={styles.quotePill}>"O quarto é o primeiro mundo da criança"</p>
      </div>
    </section>
  );
}
